<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ 'FORMS_TEMPLATES_MODULE.FORM.LINK_TITLE' | translate }}</h3>
    </div>
  </div>
  <div style="max-height: fit-content !important" class="card-body">
    <form [formGroup]="formGroup" class="form form-group mb-0">
      <div class="w-100 mb-4">
        <kt-general-autocomplete
          #dictionary
          [label]="'Dictionary'"
          [dataPath]="'data'"
          [change]="handleDictionaryChange.bind(this)"
          [loadItemsFunction]="getDictionaryAutocomplete"
          [optionFormatter]="formatDictionaryOption"
          [valueFormatter]="formatDictionaryOption"
        ></kt-general-autocomplete>
      </div>
      <fieldset class="border border-secondary rounded p-5">
        <legend
          style="width: fit-content !important; font-size: 1.1rem !important"
          class="font-weight-bolder px-4"
        >
          {{ form.name | uppercase }}
          <span class="text-muted ml-2">Fields</span>
        </legend>
        <div class="d-flex align-items-center px-5 mb-10">
          <span
            inlineSVG="assets/media/svg/icons/Code/Info-circle.svg"
            class="svg-icon mr-2"
          ></span>
          <span class="text-muted"
            >Form fields can be linked to synonyms of different dictionaries.</span
          >
        </div>
        <div
          style="max-height: 35vh !important"
          class="scroll px-5"
          [perfectScrollbar]="{ wheelPropagation: false }"
        >
          <ng-container *ngFor="let link of links">
            <div
              *ngIf="!formGroup.controls[link.field_name]?.value?.linkedTo"
              class="d-flex align-items-center mb-4"
            >
              <div class="flex-grow-1 font-weight-bold">
                <span class="text-dark-50">{{ link.label_prefix }}</span
                >{{ link.field_label }}
              </div>
              <div
                inlineSVG="assets/media/svg/icons/General/link-1.svg"
                class="svg-icon svg-icon-width-5x svg-icon-secondary d-flex flex-center"
              ></div>
              <div class="d-flex align-items-center">
                <div
                  style="width: 250px !important"
                  (click)="
                    $event.stopPropagation();
                    !dictionary.value && dictionary.recorderInput?.nativeElement.focus()
                  "
                >
                  <kt-general-autocomplete
                    #synonymAutocomplete
                    [id]="link.field_name"
                    [label]="(link.field_label | titlecase) + ' Synonym'"
                    [dataPath]="'data'"
                    [change]="handleSynonymChange.bind(this, link.field_name)"
                    [loadItemsFunction]="getSynonymAutocomplete"
                    [optionFormatter]="formatSynonymOption"
                    [valueFormatter]="formatSynonymValue"
                    [matTooltip]="dictionary.value ? null : 'Select a Dictionary!'"
                    [matTooltipPosition]="'above'"
                    [readOnly]="!dictionary.value"
                    [required]="true"
                  ></kt-general-autocomplete>
                </div>
                <div
                  [matTooltip]="
                    !synonymAutocomplete.value
                      ? 'Select a Synonym!'
                      : synonymAutocomplete.value.has_values
                      ? 'Selected synonym already has values!'
                      : null
                  "
                  style="width: 200px !important"
                  class="ml-4"
                >
                  <mat-form-field
                    *ngIf="formGroup.controls[link.field_name].value?.isSelect"
                    appearance="fill"
                    class="w-100"
                  >
                    <mat-label>{{ 'FORMS_TEMPLATES_MODULE.FORM.LOOKUP' | translate }}</mat-label>
                    <mat-select
                      [placeholder]="'FORMS_TEMPLATES_MODULE.FORM.LOOKUP' | translate"
                      [disabled]="
                        !synonymAutocomplete.value || synonymAutocomplete.value.has_values
                      "
                      [value]="formGroup.controls[link.field_name].value?.lookup"
                      (selectionChange)="handleLookupChange(link.field_name, $event.value)"
                    >
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let type of lookupTypes" [value]="type">{{
                        type | titlecase
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </fieldset>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
